import { render, staticRenderFns } from "./_cookie-banners.vue?vue&type=template&id=4a0b3008"
import script from "./_cookie-banners.vue?vue&type=script&lang=js"
export * from "./_cookie-banners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports